import kitchen_cover from '../../../../static/kitchen_cover.png';
import hallway_cover from '../../../../static/hallway_cover.png';
import bathroom_cover from '../../../../static/bathroom_cover.png';
import bedroom_cover from '../../../../static/bedroom_cover.png';
import garage_cover from '../../../../static/garage_cover.png';
import living_cover from '../../../../static/living_cover.png';
import google_logo from '../../../../static/google.png';
import apple_logo from '../../../../static/apple_logo.png';
import envelope from '../../../../static/envelope.png';
import footer_back from '../../../../static/footerBack.png';
import footer_back2 from '../../../../static/footerBack2.png';
import bar from '../../../../static/bar.png';
import arrow_top from '../../../../static/arrow-top.png';

declare interface ImageList {
  [key: string]: string;
}

const Images: ImageList = {
  kitchen_cover: kitchen_cover,
  default_cover: kitchen_cover,
  hallway_cover: hallway_cover,
  living_cover: living_cover,
  garage_cover: garage_cover,
  bedroom_cover: bedroom_cover,
  bathroom_cover: bathroom_cover,
  google_logo: google_logo,
  apple_logo: apple_logo,
  envelop: envelope,
  footer_back: footer_back,
  footer_back2: footer_back2,
  bar: bar,
  arrow_top: arrow_top,
};

export default Images;
